import { client } from '../client';
import {
  CreateTransferBatchRequest,
  TransferBatch,
  TransferBatchList,
  UpdateTransferBatchRequest,
} from '~/typings/API';
import { convertValues } from '~/util';

export interface TransferBatchListParams {
  limit?: number;
  startingAfter?: string;
}

export class TransferBatchRepository {
  static async create(request: CreateTransferBatchRequest, idempotency?: string) {
    return client
      .post<CreateTransferBatchRequest, TransferBatch>('/transfers/batches', request, { idempotency })
      .then((response) => convertValues<TransferBatch>(response));
  }

  static async delete(transferBatchId: string, idempotency?: string) {
    return client
      .delete<unknown, TransferBatch>(`/transfers/batches/${transferBatchId}`, { idempotency })
      .then((response) => convertValues<TransferBatch>(response));
  }

  static async get(request: GetRequestType) {
    return client
      .get<unknown, TransferBatch>(`/transfers/batches/${request.id}`)
      .then((response) => convertValues<TransferBatch>(response));
  }

  static async getAll(query?: Partial<TransferBatchListParams>) {
    return client.get<TransferBatchListParams, TransferBatchList>('/transfers/batches', { query }).then((response) => ({
      batches: Array.isArray(response?.transferBatches)
        ? response.transferBatches.map((e) => convertValues<TransferBatch>(e))
        : [],
      hasMore: Boolean(response?.hasMore),
    }));
  }

  static async update(transferBatchId: string, request: UpdateTransferBatchRequest) {
    return client
      .patch<UpdateTransferBatchRequest, TransferBatch>(`/transfers/batches/${transferBatchId}`, request)
      .then((response) => convertValues<TransferBatch>(response));
  }
}
